import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Table } from 'react-bootstrap';
import * as Common from '../Common';

const Report = (props) => {

    const { id } = useParams();
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [userRight, setUserRight] = useState([]);
    const [orderRepData, setOrderRepData] = useState([]);
    const [orderRepIndData, setOrderRepIndData] = useState([]);
    const [amountInWords, setAmountInWords] = useState('');

    useEffect(() => {
        const orderRepData = JSON.parse(localStorage.getItem("orderRepData"));
        const orderRepIndData = JSON.parse(localStorage.getItem("orderRepIndData"));
        const amountInWords = localStorage.getItem("amountInWords");

        setOrderRepData(orderRepData);
        setOrderRepIndData(orderRepIndData);
        setAmountInWords(amountInWords);
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'ORDER_REPORT'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                }

            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const style = {
        border: '0px solid black',
        fontSize: '12px',
        fontFamily: 'Times New Roman',
        lineHeight: '0.7',
    }

    const style1 = {
        fontSize: '11px',
        fontFamily: 'Times New Roman',
    }

    return (
        <>
            <Container fluid>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ textAlign: 'right' }}>
                        <p style={{ fontSize: '12px', fontFamily: 'Times New Roman', margin: 0 }}>
                            Date: {new Date().toLocaleDateString('en-GB')}
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p style={style1}>
                            The Branch Manager, <br />
                            ZENITH LEISURE HOLIDAYS LIMITED ({orderRepData[0]?.entity_name})<br />
                            {orderRepData[0]?.entity_address1} <br />
                            {orderRepData[0]?.entity_address2} <br />
                            {orderRepData[0]?.entity_address3} <br />
                            Dear Sir,<br />
                            Request: Application for Foreign Exchange<br />
                            This is to request you to issue me foreign exchange as requested below.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Table style={{
                        border: '2px solid black',
                        borderCollapse: 'collapse',
                        width: '100%',
                        padding: 0,  // Equivalent to cellpadding="0"
                        borderSpacing: 0 // Equivalent to cellspacing="0"
                    }}>
                        <tbody>
                            <tr><td style={style}>Purpose of Remittance:  {orderRepData[0]?.purpose_name}</td>
                                <td style={style}>Mode of Remittance:  {orderRepData[0]?.req_productcode}</td></tr>
                            <tr><td style={style}>FCY Currency:  {orderRepData[0]?.req_isd}</td>
                                <td style={style}>FCY Amount:  {Number(orderRepData[0]?.req_quantity).toFixed(2)} </td></tr>
                            <tr><td style={style}>INR Amount:   {Number(orderRepData[0]?.total_value).toFixed(2)}</td>
                                <td></td></tr>
                        </tbody>
                        <tbody>
                            <tr><td style={style}>Details Of the remitter: </td>
                                <td style={style}>Nationality:  {orderRepIndData[0]?.cnt_name}</td></tr>
                            <tr><td style={style}>PAN:  {orderRepIndData[0]?.bd_pan}</td>
                                <td style={style}>Name:  {orderRepIndData[0]?.bd_name}</td></tr>
                            <tr><td style={style}>Address:  {orderRepIndData[0]?.bd_address}</td>
                                <td style={style}>Number:  {orderRepIndData[0]?.mpid_id_number}</td></tr>
                            <tr><td style={style}>Date of Issue:  {orderRepIndData[0]?.mpid_issue_date}</td>
                                <td style={style}>Place of Issue:  {orderRepIndData[0]?.mpid_issue_place}</td></tr>
                            <tr><td style={style}>Validity:  {orderRepIndData[0]?.mpid_expiry_date}</td></tr>
                        </tbody>
                        <tbody>
                            <tr><td style={style}>Details of the Benificiary :</td>
                                <td style={style}>Name:  {orderRepData[0]?.req_benename}</td></tr>
                            <tr><td style={style}>Account Number:  {orderRepData[0]?.req_benebankacct}</td>
                                <td style={style}>Banker:  {orderRepData[0]?.req_benebank}</td></tr>
                            <tr><td style={style}>Address:  {orderRepData[0]?.req_benebankadd}</td>
                                <td style={style}>Swift Code:  {orderRepData[0]?.req_beneswiftcode}</td></tr>
                        </tbody>
                    </Table>
                </Row>
                <Row>
                    <p style={style1}>
                        {/* Billing Amount (Include Of GST & TCS)*: RS. {orderRepData[0]?.total.toFixed(2)} ({amountInWords}) */}
                        Billing Amount (Include Of GST & TCS)*: RS. {Number(orderRepData[0]?.total).toFixed(2)} ({amountInWords})
                        <br />
                        I/We hereby Declare that the transaction the details Of which are specifically mentioned In<br />
                        the application above does Not involve, And Is Not designed For the purpose Of any<br />
                        contravention Or evasion Of the provisions u/s 10 (5) chapter III Fema 1999 Or Of any<br />
                        rule, regulation, notification, direction Or order made there under. I/We also hereby agree<br />
                        And undertake To give such information/documents As will reasonably satisfy you about<br />
                        this transaction In terms Of the above declaration. <br />

                        I/We also understand that If I/We refuse To comply With any such requirement Or make<br />
                        only unsatisfactory compliance therewith, the Authorised Dealer shall refuse In writing<br />
                        To undertake the transactin And shall If it has reason To believe that any contravention/evasion<br />
                        Is contemplated To Me/us report the matter To Reserve Bank Of India. <br />

                        I/We further Declare that the undersigned has/have the authority To give this<br />
                        declaration And undertaking On behalf Of the firm/company.<br />

                        I hereby Declare that the above details are True And that this remittance along With my <br />
                        previous remittance does Not exceed the limitation, under the category, allowed As per<br />
                        RBI Regulation.<br /><br />

                        Whether the total remittance made outside India during the current financial year, through all banks / Reserve Bank of India Authorised Dealers / financial institutions / NBFCs, exceeds Rs. 10 Lakhs?<br /><br />
  


                        Signature of the Remitter: _______________________________________<br />
                        <center><b>Certificate by the Authorised Dealer</b></center>
                        This Is To certify that the remittance Is Not being made by/ To ineligible entities And that the remittance Is In conformity With the instructions issued by the <br /> Reserve Bank from time To time under the Scheme. I have verified KYC documents In original. <br />
                    </p>
                    <p style={style1}>Name And designation Of the authorised official:</p>
                    <p style={style1}>
                        Stamp And seal<br />
                        Signature ___________________ Date __________________ Place _______________
                    </p>
                </Row>
                <Row>&nbsp;</Row>
            </Container>
        </>
    );
}

export default Report;
